// DON'T EDIT THIS FILE!! IT'S AUTO-GENERATED USING GRAPHQL-CODE-GENERATOR CLI
/* eslint-disable camelcase */
import * as Types from '../../../Types/__generated__/types';

import gql from 'graphql-tag.macro';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';

export type CouponLandingValidateEmailQueryQueryVariables = Types.Exact<{
  value: Types.Scalars['String'];
}>;

export type CouponLandingValidateEmailQueryQuery = {
  __typename?: 'PublicQueryDebug';
  verifyUser?: Types.Maybe<{
    __typename?: 'ValidateUserNode';
    success?: Types.Maybe<boolean>;
    messages?: Types.Maybe<
      Array<
        Types.Maybe<{
          __typename?: 'MessageNode';
          field?: Types.Maybe<string>;
          message?: Types.Maybe<string>;
        }>
      >
    >;
  }>;
};

export const CouponLandingValidateEmailQueryDocument = gql`
  query CouponLandingValidateEmailQuery($value: String!) {
    verifyUser(value: $value) {
      success
      messages {
        field
        message
      }
    }
  }
`;

/**
 * __useCouponLandingValidateEmailQueryQuery__
 *
 * To run a query within a React component, call `useCouponLandingValidateEmailQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouponLandingValidateEmailQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouponLandingValidateEmailQueryQuery({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCouponLandingValidateEmailQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CouponLandingValidateEmailQueryQuery,
    CouponLandingValidateEmailQueryQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    CouponLandingValidateEmailQueryQuery,
    CouponLandingValidateEmailQueryQueryVariables
  >(CouponLandingValidateEmailQueryDocument, baseOptions);
}
export function useCouponLandingValidateEmailQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CouponLandingValidateEmailQueryQuery,
    CouponLandingValidateEmailQueryQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    CouponLandingValidateEmailQueryQuery,
    CouponLandingValidateEmailQueryQueryVariables
  >(CouponLandingValidateEmailQueryDocument, baseOptions);
}
export type CouponLandingValidateEmailQueryQueryHookResult = ReturnType<
  typeof useCouponLandingValidateEmailQueryQuery
>;
export type CouponLandingValidateEmailQueryLazyQueryHookResult = ReturnType<
  typeof useCouponLandingValidateEmailQueryLazyQuery
>;
export type CouponLandingValidateEmailQueryQueryResult =
  ApolloReactCommon.QueryResult<
    CouponLandingValidateEmailQueryQuery,
    CouponLandingValidateEmailQueryQueryVariables
  >;
export function refetchCouponLandingValidateEmailQueryQuery(
  variables?: CouponLandingValidateEmailQueryQueryVariables,
) {
  return {
    query: CouponLandingValidateEmailQueryDocument,
    variables,
  };
}
